export { default, VendorDetailMemo } from './VendorDetails';
